import React from 'react';
import './TimerPage.scss';
import BDWLogoWhite from '../../assets/images/bdwLogoWhite.png'
import TimerComponent from '../TimerComponent/TimerComponent';

const TimerPage = () => {

    return (
        <div className='timer-page-container' id='scrollElement0'>
            <div className='arrows-cluster'>
                <img src={BDWLogoWhite} alt='BDW Logo' className='bdw-big-logo'/>
                
                {/*<button className='prijava-btn desktop-version' onClick={() => window.open("https://docs.google.com/forms/d/e/1FAIpQLSf_4HlDq_FUmOTwuuyhzL4fiXdvje-4nZQO7d8T4MfcC4Bt8A/viewform?usp=header", "_blank")}>Prijavi se!</button>*/}
            </div>
            <TimerComponent></TimerComponent>
            {/*<button className='di-prijava-btn top-20px' onClick={() => window.open("https://docs.google.com/forms/d/e/1FAIpQLSe2bqwjlz4PGORJ8VKrFmyJqn6xQ8XcOA6HFD0WyJPzwidkJQ/viewform", "_blank")}>Prijavi se</button>
            {/*<div className='di-prijava-div'>
                <h3 className='di-prijava-title'>Takođe, popuni prijavu i za <br className='mobile-br'></br>Design Insight!</h3>
                <button className='di-prijava-btn' onClick={() => window.open("https://docs.google.com/forms/d/e/1FAIpQLSe__VDPn7P92RZk3GfuiJML1v-ilE6kmnwqQdmYkU4ic2QTUA/viewform", "_blank")}>Design Insight<br></br>Prijava</button>
            </div>*/}
        </div>
    )
}

export default TimerPage;